
    <ng-content></ng-content>
    <span
      class="text-danger"
      [ngClass]="{'pl-1': hasSpace}"
      data-testid="lbl_required_tag"
      id="lblRequiredTag"
      [innerText]="asterisk"
    ></span>
  